import { render, staticRenderFns } from "./VehicleStatusToggle.vue?vue&type=template&id=639052c2&scoped=true&"
import script from "./VehicleStatusToggle.vue?vue&type=script&lang=js&"
export * from "./VehicleStatusToggle.vue?vue&type=script&lang=js&"
import style0 from "./VehicleStatusToggle.vue?vue&type=style&index=0&id=639052c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639052c2",
  null
  
)

export default component.exports